import Vue from 'vue'
import Vuex from 'vuex'
// import Api from '@/api'
import auth from './auth'
import password from './password'
import signup from './signup'
import user from './user'
import _ from 'lodash'
import config from '../api/config'
import router from '../router'
import { eventHub } from '../main.js'

Vue.use(Vuex)

// console.log('user agent --> ', navigator.userAgent)

// the REST ip is different in for selenium
// because is within docker
let REST_URL = config.baseurl
if (navigator.userAgent.includes('selenium')) {
  REST_URL = 'http://backend:8000'
}

export const store = new Vuex.Store({
  modules: {
    auth,
    password,
    signup,
    user
  },
  strict: true,
  state: {
    editorConfig: {
      isMobile: false,
      isSketchRunning: false,
      isPreviewingFullscreen: false,
      isShowingMediaFacadeCutout: true,
      isShowingInfoOverlay: true,
      isShowingAuthDecider: false,
      isShowingLogin: false,
      isShowingRegister: false,
      isSketchScaled: true,
      isShowingSettings: false,
      isShowingCreateProject: false,
      isShowingHelp: false,
      isShowingToolbar: true,
      isShowingTabs: true,
      isShowingPreview: true,
      isShowingSubmit: false,
      isShowingSideMenu: false,
      isShowingNewClassroom: false,
      selectedModule: -1,
      tabSelected: 0,
      changesCounter: 0,
      videoPlayerShouldStartPlaying: false,
      isShowingAlphaVersionBanner: false,
      showBrokenLeds: false
    },
    console: [],
    storagePreview: {},
    createProjectOptions: {},
    project: {},
    examples: {
      list: [],
      loaded: null
    },
    gallery: {
      filter: null,
      pageSize: 30,
      numPages: 0,
      size: 0,
      fetched: [],
      tags: [],
      calls: [],
      isLoading: false,
      codeAnalysisMetadata: null
    },
    activeCalls: [],
    lastServerError: {}
  },
  // if we have to modify the state before using it
  getters: {
    getIsUserAdmin: state => {
      // console.log('auth', state.auth.userid)
      return state.auth.userid === 906 || state.auth.userid === 268
    },
    getIsProjectOnDb: state => {
      if (state.project && state.project.id) return true
      else return false
    },
    getSelectedTabCodefile: state => {
      // console.log('store getter getcurrentcodefile')
      // console.log(state.project)
      // console.log(state.project.codefiles)
      if (!state.project.codefiles) {
        return ''
      } else {
        return state.project.codefiles[state.editorConfig.tabSelected]
      }
    },
    getIsProjectWritable: state => {
      if (Vue._.isEmpty(state.project)) { // ?
        return true
      }
      if (state.project && state.project.config && state.project.config.is_example) return false // ejemplo

      let amIOwner = false
      if (state.project.owner) {
        if (state.project.owner.id === state.auth.userid) amIOwner = true
      }
      // const amIOwner = (state.project.owner === null || state.project.owner.id === state.auth.userid) // if I am the owner or it is anonymous : writable
      const isProjectFinished = state.project.is_finished // if it is finished it won't be writable
      const isProjectAnonymous = (state.project.owner === null || state.project.owner.id === null)
      if (isProjectFinished) return false // if finished I cannot edit. end.
      else if (isProjectAnonymous && !isProjectFinished) return true // if it is anonymous and not finihsed i can edit it
      else if (!isProjectFinished && amIOwner) return true // if it is mine and not finished I can edit it
      else return false
    },
    getIsProjectCloneable: state => {
      if (state.project.config && state.project.config.is_example) return true
      if (state.project === undefined) return false
      if (state.project.id === undefined) return false // non saved
      if (state.project.owner === undefined) return false // anonymous
      const isProjectAnonymous = (state.project.owner === null)
      if (isProjectAnonymous) {
        return true
      }
      // si llego aqui es porque el proyecto no es anonimo
      // if project is mine and not finished
      if (state.project.owner.id === state.auth.userid && state.project.is_finished === false) {
        return false
      } else return true
    },
    getIsProjectSubmitable: state => {
      // si es mio y estoy autenticado
      if (state.project === undefined) return false
      if (state.project.owner === undefined) return false
      const isProjectAnonymous = (state.project.owner === null)
      if (isProjectAnonymous) {
        return false
      }
      // si es mio
      if (state.project.owner.id === state.auth.userid && state.project.is_finished === false) {
        return true
      } else {
        return false
      }
    },
    getIsProjectExample: state => {
      if (state.project && state.project.config && state.project.config.is_example) return true
      else return false
    }
    /*
      ,
    getProject: state => projectId => {
      console.log('getProject', projectId)
      if (state.project) {
        return state.project
      } else return {}
    }
    */
    // here next getter
  },
  // here is what modifies the global state
  mutations: {
    setExamplesList: (state, examples) => {
      state.examples = examples
    },
    setProjectList: (state, gallery) => {
      if (!gallery) {
        state.gallery.isLoading = true
      } else {
        state.gallery.isLoading = false
        state.gallery.fetched = gallery
        state.gallery.numPages = Math.ceil(gallery.count / state.gallery.pageSize)
        // console.log(state.gallery.numPages)
      }
    },
    setTagList: (state, tags) => {
      state.gallery.tags = tags
    },
    setCallList: (state, calls) => {
      state.gallery.calls = calls
    },
    setActiveCallList: (state, calls) => {
      state.activeCalls = calls
    },
    setCodeAnalysisMetadata: (state, metadata) => {
      state.gallery.codeAnalysisMetadata = metadata
    },
    clearProject: (state) => {
      state.project = {}
      state.editorConfig.isSketchRunning = false
    },
    setCreateProjectOptions: (state, options) => {
      state.createProjectOptions = options
    },
    setProject: (state, project) => {
      console.log('settingProject')
      // let codefiles = project.codefiles
      // let codefiles2 = _.orderBy(codefiles, [codefiles => codefiles.name.toLowerCase()], ['desc'])
      // console.log(codefiles2)

      let codefiles = _.orderBy(project.codefiles, function (el) {
        return el.name.toLowerCase()
      }, ['asc'])
      codefiles = _.orderBy(codefiles, function (el) {
        return el.name === 'main' ? 0 : 1
      })
      project.codefiles = codefiles

      state.editorConfig.changesCounter = 0
      Vue.set(state, 'project', project)
      state.editorConfig.tabSelected = 0
    },
    setCode: (state, codeChanges) => {
      state.editorConfig.changesCounter = state.editorConfig.changesCounter + 1
      state.project.codefiles[state.editorConfig.tabSelected].code = codeChanges.code
    },
    addCodeFile: (state, file) => {
      state.project.codefiles.push(file)
    },
    renameCodeFile: (state, newName) => {
      let file = state.project.codefiles[state.editorConfig.tabSelected]

      let i = state.project.codefiles.map(item => item.id).indexOf(file.id) // find index of your object
      state.project.codefiles[i].name = newName
    },
    removeCodeFile: (state, file) => {
      let i = state.project.codefiles.map(item => item.id).indexOf(file.id) // find index of your object
      state.project.codefiles.splice(i, 1) // remove it from array
    },
    setEditorConfigProperty: (state, values) => {
      let prop = Object.getOwnPropertyNames(values)
      for (let i in prop) {
        state.editorConfig[prop[i]] = values[prop[i]]

        if (prop[i] === 'isSketchRunning' && values[prop[i]]) {
          state.console = []
        }
      }
    },
    setChangesCounter: (state, n) => {
      state.editorConfig.changesCounter = 0
    },
    setProjectProperty: (state, values) => {
      let prop = Object.getOwnPropertyNames(values)
      for (let i in prop) {
        state.project[prop[i]] = values[prop[i]]
      }
    },
    setProjectFinished: (state) => {
      state.project.is_finished = true
    },
    setProjectPublic: (state) => {
      state.project.is_public = true
    },
    addConsoleLine: (state, line) => {
      state.console.push(line)
    },
    clearConsole: (state) => {
      state.console = []
    },
    setStoragePreview: (state, data) => {
      state.storagePreview = data
    },
    setServerError: (state, errorResponse) => {
      state.lastServerError = errorResponse
    }
  },
  // If we have to do any async call like any network operation
  // we must use actions
  // https://www.youtube.com/watch?v=arhCOcxIUo4
  actions: {
    fetchExamplesList: (context) => {
      var query = { }

      Vue.axios.get('/static/examples/examples.json', query).then((response) => {
        context.commit('setExamplesList', response.data)
      }, function (response) {
        console.log('fetchExamplesList', 'FAIL', response.status)
      })
    },
    fetchExample: (context, example) => {
      var query = { }
      context.commit('setEditorConfigProperty', {'tabSelected': -1})

      Vue.axios.get('/static/examples/' + example.type + '/examples/' + example.id, query).then((response) => {
        // we use the same structure than the database
        let project = {
          cover: null,
          name: example.id,
          config: { type: example.type, is_example: true },
          description: 'Example',
          codefiles: [ { name: 'main', code: response.data } ],
          owner: {
            'id': context.state.auth.userid
          },
          tags: []
        }
        // console.log(project.codefiles[0].code)
        context.commit('setProject', project)
      }, function (response) {
        console.log('fetchExample', 'FAIL', response.status)
      })
    },
    // TODO move api calls to api/index.js
    fetchProjectList: (context, query) => {
      // we have to use URLSearchParams since axios does not
      // include many "tags" in the GET query
      context.commit('setProjectList', null)
      const params = new URLSearchParams()
      params.append('page', query.params.page)
      params.append('limit', query.params.limit)
      params.append('call', query.params.call)
      params.append('is_finished', query.params.is_finished)
      params.append('is_public', query.params.is_public)

      params.append('is_example', query.params.is_example)
      if (query.params.classroom) {
        params.append('classroom', query.params.classroom)
      }

      for (let i in query.params.tags) {
        params.append('tags', query.params.tags[i])
      }

      for (let j in query.params.codeAnalysis) {
        console.log(query.params.codeAnalysis[j])
        params.append('codeanalysis__' + j, query.params.codeAnalysis[j])
      }

      query = {
        params: params
      }
      Vue.axios.get(REST_URL + '/project/', query).then((response) => {
        context.commit('setProjectList', response.data)
      }).catch((error) => {
        console.log('fetchProjectList', 'FAIL', error)
      })
    },

    fetchTagList: (context) => {
      Vue.axios.get(REST_URL + '/tag/').then((response) => {
        context.commit('setTagList', response.data)
      }).catch((error) => {
        console.log('fetchTagList', 'FAIL', error)
      })
    },
    fetchCallList: (context) => {
      Vue.axios.get(REST_URL + '/call/').then((response) => {
        context.commit('setCallList', response.data)
      }).catch((error) => {
        console.log('fetchCallList', 'FAIL', error)
      })
    },
    fetchActiveCallList: (context) => {
      var d = new Date()
      var n = d.toISOString()
      const request = Vue.axios.get(REST_URL + '/call/', {
        params: {
          active_on: n
        }
      })
      request.then((response) => {
        context.commit('setActiveCallList', response.data)
      }).catch((error) => {
        console.log('fetchCallList', 'FAIL', error)
      })
      return request
    },
    fetchCodeAnalysisMetadata: (context) => {
      Vue.axios.options(REST_URL + '/codeanalysis/').then((response) => {
        context.commit('setCodeAnalysisMetadata', response.data)
      }).catch((error) => {
        console.log(error)
      })
    },
    fetchProject: (context, projectId) => {
      context.commit('setEditorConfigProperty', {'tabSelected': -1})
      return Vue.axios.get(REST_URL + '/project/' + projectId + '/').then(response => {
        // console.log('fetchProject', 'OK', response.data)
        context.commit('setProject', response.data)
        return response
      }).catch((error) => {
        console.log('fetchProject', 'FAIL', error)
        if (error.response.status === 403 || error.response.status === 401) throw error
      })
    },
    handleSaveProject: (context) => {
      // save to db if the project has an id (already saved)
      // otherwise create a new project
      if (store.state.project.id) {
        store.dispatch('saveProject')
      } else {
        store.dispatch('createProjectInDb')
      }
      store.commit('setChangesCounter', 0)
    },
    saveProject: (context) => {
      var projectInfoCustom = Vue._.omit(store.state.project, 'cover')
      if (projectInfoCustom.owner !== null) {
        projectInfoCustom.owner = projectInfoCustom.owner.id
      }
      localStorage.setItem('projectId', store.state.project.id)
      const request = Vue.axios.put(REST_URL + '/project/' + store.state.project.id + '/', projectInfoCustom)
      request.then(response => {
        eventHub.$emit('showToast', 'Proyecto guardado')
      }).catch((error) => {
        console.log('saveProject', 'FAIL', error)
        eventHub.$emit('showToast', 'Error al guardar')
      })
      return request
    },
    saveCoverProject: (context, file) => {
      const data = new FormData()
      data.append('cover', file, store.state.project.id + '.png')
      // now upload
      const config = {
        headers: { 'Content-Type': 'multipart/form-data' }
      }
      Vue.axios.patch(REST_URL + '/project/' + store.state.project.id + '/', data, config).then(response => {
      })
    },
    saveProjectSettings: (context) => {
      var projectInfoCustom = Vue._.omit(store.state.project, ['cover', 'codefiles', 'tags', 'config'])
      if (projectInfoCustom.owner !== null) {
        projectInfoCustom.owner = projectInfoCustom.owner.id
      }
      const request = Vue.axios.patch(REST_URL + '/project/' + store.state.project.id + '/', projectInfoCustom)
      request.then(response => {
        eventHub.$emit('showToast', 'Proyecto guardado')
      }).catch((error) => {
        console.log('saveProject', 'FAIL', error)
        eventHub.$emit('showToast', 'Error al guardar')
      })
      return request
    },
    createProjectWithoutSaving: (context) => {
      // Vue._.defaults(store.state.createProjectOptions, {projectType: 'p5js', classroom: null})
      context.commit('setEditorConfigProperty', {'tabSelected': -1})
      let options = store.state.createProjectOptions

      let query = {}
      Vue.axios.get('/static/examples/' + options.projectType + '/templates/template.js', query).then((response) => {
        // console.log('fetchExamples', 'OK', response.data)
        // we use the same structure than the database
        let project = {
          classroom: options.classroom,
          name: 'Sin Nombre',
          owner: {
            'id': context.state.auth.userid
          },
          config: {
            type: options.projectType
          },
          tags: [],
          description: '',
          codefiles: [ { name: 'main', code: response.data } ]
        }
        context.commit('setProject', project)
      }, function (response) {
        console.log('fetchExample', 'FAIL', response.status)
      })
    },
    createProjectInDb: (context, projectId) => {
      var projectInfoCustom = Vue._.cloneDeep(store.state.project)
      projectInfoCustom.owner = projectInfoCustom.owner.id
      const request = Vue.axios.post(REST_URL + '/project/', projectInfoCustom)
      request.then(response => {
        context.commit('setProject', response.data)
        localStorage.setItem('projectId', store.state.project.id)
        if (!store.state.auth.token) {
          eventHub.$emit('createdProjectInDb')
        }
        router.replace('/editor/' + response.data.id + '/')
      }).catch(e => {
        // this.errors.push(e)
        console.log(e)
      })
      return request
    },
    createProjectInDbSimple: (context, projectId) => { // do not emite event to eventhub, do not change url, just create the project
      var projectInfoCustom = Vue._.cloneDeep(store.state.project)
      projectInfoCustom.owner = Vue._.get(projectInfoCustom, 'owner.id', null)
      const request = Vue.axios.post(REST_URL + '/project/', projectInfoCustom)
      request.then(response => {
        context.commit('setProject', response.data)
        localStorage.setItem('projectId', store.state.project.id)
      }).catch(e => {
        // this.errors.push(e)
        console.log(e)
      })
      return request
    },
    createCodeFile: (context, filename) => {
      const request = Vue.axios.post(REST_URL + '/codefile/', {'project': store.state.project.id, 'name': filename})
      return request.then(response => {
        console.log(response.data)
        context.commit('addCodeFile', response.data)
      }).catch(e => {
        eventHub.$emit('showToast', 'No se puede crear este archivo, prueba a crear uno con distinto nombre')
        console.log(e)
      })
    },
    deleteCodeFile: (context, file) => {
      const request = Vue.axios.delete(REST_URL + '/codefile/' + file.id)
      request.then(response => {
        context.commit('removeCodeFile', file)
      }).catch(e => {
        eventHub.$emit('showToast', 'No se puede borrar este archivo')
        console.log(e)
      })
    },
    cloneProject: (context, projectId) => {
      const request = Vue.axios.post(REST_URL + '/cloneproject/', {'projectId': projectId})
      request.then(response => {
        // se clona en el mismo tab
        router.replace('/editor/' + response.data.id + '/')
        eventHub.$emit('showToast', 'Proyecto clonado con éxito. Ahora puedes editarlo')
      }).catch(e => {
        // this.errors.push(e)
        console.log(e)
      })
    },
    cloneExample: (context, projectId) => {
      // for this function we consider that the example is already loaded and state.project contains interval
      // 1st we change the name
      context.state.project.name += ' - cloned '
      context.state.project.config.isExample = false
      context.dispatch('createProjectInDb')
      eventHub.$emit('showToast', 'Proyecto clonado con éxito. Ahora puedes editarlo')
    },
    deleteProject: (context, projectid) => {
      return Vue.axios.delete(REST_URL + '/project/' + projectid)
        .catch(e => {
          console.log(e)
          throw e
        })
    }
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/store.js